import { CHNDeliveryAddressFormutil, CHNDeliveryAddressProps } from './CHN';
import { CommonDeliveryAddressFormutil, CommonDeliveryAddressProps } from './Common';
import { Common2DeliveryAddressFormutil, Common2DeliveryAddressProps } from './Common2';
import { USADeliveryAddressFormutil, USADeliveryAddressProps } from './USA';

export enum DeliveryAddressTypeEnum {
    USA = 'USA',
    COMMON = 'COMMON',
    COMMON2 = 'COMMON2',
    CHN = 'CHN'
}

export interface BaseDeliveryAddressProps {
    disabled?: boolean;
    hasCountry?: boolean;
    countryDisabled?: boolean;
    deliveryCountry?: string;
}

export interface DeliveryAddressProps
    extends USADeliveryAddressProps,
        CommonDeliveryAddressProps,
        Common2DeliveryAddressProps,
        CHNDeliveryAddressProps {
    deliveryAddressType?: DeliveryAddressTypeEnum;
    isFourChn?: boolean;
    isSSN: boolean;
}

export type DeliveryAddressFormutil = CommonDeliveryAddressFormutil &
    Common2DeliveryAddressFormutil &
    USADeliveryAddressFormutil &
    CHNDeliveryAddressFormutil;
